import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { CallsTable } from "@/components/shared/DrillDownTable";
import { useRecordCalls, type CallRecordType } from "@/lib/hooks/use-record-calls";

/**
 * Calls tab body for Person / Company / Deal detail sheets: HubSpot-synced CALL
 * engagements with "Load More" paging, the same as the Emails tab. `enabled`
 * gates the query (sheet open + CALLS_TAB flag), so a workspace without the
 * flag never fetches calls.
 */
export default function RecordCallsTab({
  recordType,
  recordId,
  enabled,
}: {
  recordType: CallRecordType;
  recordId: string;
  enabled: boolean;
}) {
  const { t } = useTranslation();
  const { calls, hasMore, loadMore } = useRecordCalls({ recordType, recordId, skip: !enabled });

  return (
    <>
      <CallsTable calls={calls} />
      {hasMore && calls.length > 0 && (
        <div className="flex justify-center py-4">
          <Button onClick={loadMore} variant="outline" size="sm">
            {t("detailSheets.loadMore")}
          </Button>
        </div>
      )}
    </>
  );
}
